@if (form?.get('heldFinancialInstruments')?.value?.length == 0 && derrors) {
  <info [option]="optionInfo1"> vous devez choisir au moins une option </info>
}

<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-template #optionTemplate let-option let-id="index">
      @if (check(option.value)) {
        <div class="row">
          <div class="col-md-12">
            <pr-input-column
              label="Précisez autres instruments financiers"
              [derrors]="derrors"
              [isDefault]="false"
            >
              <input
                formControlName="heldFinancialInstrumentsOther"
                type="text"
              />
            </pr-input-column>
          </div>
        </div>
      }
    </ng-template>
    <ng-template #default></ng-template>

    <div class="checkbox">
      <pr-checkbox-group
        formControlName="heldFinancialInstruments"
        [template]="optionTemplate"
        [options]="options"
      >
      </pr-checkbox-group>
    </div>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
